import styled from "styled-components";
import "../playstation25/font/font.css";

export const MainContainer = styled.main`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 480px;
  margin: auto;
  min-height: 100vh;
  background-color: #00439c;
  justify-content: flex-start;
  font-family: "SST", sans-serif;
`;

export const Navbar = styled.nav`
  display: flex;
  flex-direction: column;
  padding: 0 20px;
  cursor: pointer;

  .navbar-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
    height: 85px;
    padding: 15px 0;
  }

  img {
    height: 53px;
  }

  .balance-container {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 0;
    justify-content: flex-end;
  }

  .balance-text {
    text-align: right;
    color: rgba(255, 255, 255, 0.92);
    font-family: "SST", sans-serif;
    font-size: 18px;
    font-weight: 300;
    line-height: 24px;
    letter-spacing: 0.15px;
    margin: 0;
  }

  .balance-value {
    color: rgba(255, 255, 255, 0.92);
    text-align: right;
    font-family: "SST", sans-serif;
    font-size: 18px;
    font-weight: 300;
    line-height: 24px;
    letter-spacing: 0.15px;
    margin: 0;
  }
`;

export const NavbarSeparator = styled.div`
  width: 100%;
  height: 1px;
  background-color: #fff;
  flex-shrink: 0;
`;

export const Page = styled.div`
  background-color: #00439c;
  color: #ffffff;
  padding: 24px 25px 20px;
  font-family: "SST", sans-serif;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;

  .link {
    text-decoration: underline;
    color: #fff;
  }
`;

export const Heading = styled.p.attrs({
  role: "heading",
  "aria-level": 1
})`
  font-size: 27px;
  font-weight: 900;
  line-height: 40px;
  text-align: center;
  font-family: "SST", sans-serif;
  font-synthesis: none;
  letter-spacing: -0.02em;
  white-space: nowrap;
  color: #fff;
  width: 100%;
  margin: 0;
`;

export const SubHeading = styled.p.attrs({
  role: "heading",
  "aria-level": 2
})`
  font-size: 20px;
  font-weight: 700;
  line-height: 36px;
  text-align: center;
  font-family: "SST", sans-serif;
  font-synthesis: none;
  color: #fff;
  width: 100%;
  min-height: 39px;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Paragraph = styled.p`
  font-size: 15px;
  font-weight: 300;
  line-height: 24px;
  text-align: ${({ align }) => align || "center"};
  letter-spacing: 0.5px;
  font-family: "SST", sans-serif;
  color: #fff;
  width: 100%;
  margin: 0;
`;

export const ScheduleDay = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  width: 100%;
`;

export const DayLabel = styled.p`
  font-size: 15px;
  font-weight: 400;
  line-height: 25px;
  text-align: left;
  font-family: "SST", sans-serif;
  color: #fff;
  width: 100%;
  margin: 0;
  letter-spacing: 0;
  min-height: 25px;
`;

export const ScheduleItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: ${({ $multiline }) => ($multiline ? "flex-start" : "center")};
  gap: 20px;
  width: 100%;
`;

export const ScheduleText = styled.p`
  flex: 1;
  min-width: 0;
  margin: 0;
  font-family: "SST", sans-serif;
  font-size: 15px;
  font-weight: 300;
  line-height: 24px;
  letter-spacing: 0.5px;
  color: #fff;
  text-align: left;
`;

export const Separator = styled.div`
  width: ${({ fullWidth }) => (fullWidth ? "100%" : "100px")};
  height: 1px;
  background-color: #fff;
  flex-shrink: 0;
  margin: 0;
`;

export const Time = styled.div`
  font-size: 15px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0.5px;
  font-family: "SST", sans-serif;
  color: #fff;
  width: 92px;
  flex-shrink: 0;
  text-align: left;

  p {
    margin: 0;
    font-weight: 700;
    line-height: 24px;
  }
`;

export const FondoWrapper = styled.div`
  width: 100%;
  height: 120px;
  position: relative;
  flex-shrink: 0;
  overflow: hidden;
  background-color: #00439c;
`;

export const FooterImage = styled.img`
  display: block;
  width: 100%;
  height: 100%;
`;

export const Footer = styled.footer`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 32px 16px 26px;
  gap: 10px;
  background-color: #000000;

  img {
    height: 33px;
  }

  .powered-by {
    color: #fff;
    font-family: "Inter", sans-serif;
    font-size: 20px;
    font-weight: 700;
    line-height: 28px;
    margin: 0;
  }

  .payment-provider-label {
    color: #fff;
    font-family: "Inter", sans-serif;
    font-size: 12px;
    font-weight: 300;
    line-height: 24px;
    letter-spacing: 0.4px;
    margin: 0;
  }

  .payme-logo {
    height: 48px;
    width: auto;
    cursor: pointer;
  }

  a {
    font-family: "Inter", sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0.5px;
    text-decoration: underline;
    color: #fff;
  }

  p {
    color: white;
    margin: 0;
  }

  .footer-links {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
  }

  .copyToClipboard {
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-items: center;
    margin-top: 6px;

    img {
      width: 16px;
      height: 16px;
      cursor: pointer;
    }
  }
`;
